import {
  AlignCenterOutlined,
  BookOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Card from "../../../../components/Card/Card";
import IconTag from "../../../../components/IconTag/IconTag";
import "./CourseHighLight.scss";
import useTrainingDetails from "../../logic/useTrainingDetails";
import { UserIcon } from "../../../../assets/icons/Icons";

const fullName = (firstName, lastName) => {
  return firstName + " " + lastName;
};
function CourseHighLight() {
  const { trainingData } = useTrainingDetails();
  let userImg = `${process.env.REACT_APP_CORE_PATH}/users/avatars/${trainingData?.trainer?.image}`;

  return (
    <div className="course-highlight">
      <Card>
        <div className="highlight">
          <h2>{trainingData?.course?.title}</h2>
          <label>Learning objectives :</label>
          {trainingData?.course?.objectives && (
            <ul>
              {trainingData?.course?.objectives.map(
                (objective, index) => (
                  <li key={index}>
                    <p>{objective.objective}</p>
                  </li>
                )
              )}
            </ul>
          )}
        </div>
        <div className="trainer">
          {/* <div className="trainer-img">
            {trainingData?.trainer?.image ? (
              <img src={userImg} alt="trainerImage" />
            ) : (
              <UserIcon className="user-icon" />
            )}
            <label>
              {" "}
              {fullName(
                trainingData?.trainer?.firstName,
                trainingData?.trainer?.lastName
              ) || "Unknown"}
            </label>
          </div> */}
          <div className="trainer-info">
            <h3>Trainer</h3>
            <label className="trainer-name">
              {" "}
              {fullName(
                trainingData?.trainer?.firstName,
                trainingData?.trainer?.lastName
              ) || "Unknown"}
            </label>
            <IconTag
              Icon={AlignCenterOutlined}
              title={trainingData?.trainer?.title || "Unknown"}
              color={`#767278`}
            />
            <IconTag
              Icon={MailOutlined}
              title={trainingData?.trainer?.email || "Unknown"}
              color={`#767278`}
            />
            <IconTag
              Icon={BookOutlined}
              title={trainingData?.trainer?.external ? "Extern" : "Intern"}
              color={`#767278`}
            />
            <IconTag
              Icon={UserOutlined}
              title={`${trainingData?.courseNbTrainer} Courses`}
              color={`#767278`}
            />
          </div>
        </div>
        <button>Evaluate Training</button>
      </Card>
    </div>
  );
}
export default CourseHighLight;
